import cn from 'classnames';

import { convertToString } from 'helpers/errors';

const Error = ({ className = '', message = '', show = true }) => {
  const displayMessage = convertToString(message);

  return displayMessage && show ? (
    <p role="alert" className={cn('textSm', 'text-negative', className)}>
      {displayMessage}
    </p>
  ) : null;
};

Error.propTypes = {
  className: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Error)]),
  show: PropTypes.bool,
};

export default Error;
